import React from 'react';

// One "possible duplicate" review on Bank Feeds: the row from the bank,
// the existing eloNest row(s) it may duplicate, and the three ways to resolve
// it. Each action has its own look and a one-line hint.
const money = (v) => (v === null || v === undefined ? '-' : `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

export const ACTIONS = {
  link: {
    label: 'Same as this',
    hint: 'Links the bank row to this existing row. Nothing is added.',
    style: { background: '#15803d', color: '#fff', border: '1px solid #15803d' }
  },
  keep_both: {
    label: 'Different: keep both',
    hint: 'Adds the bank row as a new transaction.',
    style: { background: '#fff', color: '#1d4ed8', border: '1px solid #1d4ed8' }
  },
  dismiss: {
    label: "Duplicate: don't add",
    hint: 'Marks the bank row as a duplicate. Nothing is added or changed.',
    style: { background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }
  }
};

const BUTTON = { fontSize: 12, padding: '4px 10px', borderRadius: 6, cursor: 'pointer' };
const HINT = { fontSize: 11, color: '#6b7280', marginTop: 2 };
const BLOCK = { borderRadius: 6, padding: '8px 10px', marginTop: 6 };

function ActionButton({ action, onClick, disabled, testId }) {
  const a = ACTIONS[action];
  return (
    <div style={{ display: 'inline-block', marginRight: 12, verticalAlign: 'top', maxWidth: 260 }}>
      <button type="button" data-action={action} data-testid={testId} onClick={onClick} disabled={disabled}
        style={{ ...BUTTON, ...a.style, opacity: disabled ? 0.5 : 1 }}>{a.label}</button>
      <div style={HINT}>{a.hint}</div>
    </div>
  );
}

export default function MatchReviewCard({ match: m, busy = false, onResolve }) {
  const isFile = m.source === 'csv';
  return (
    <div data-testid="match-card" style={{ marginTop: 12, borderTop: '1px solid #e5e7eb', paddingTop: 8 }}>
      <div data-testid="match-source" style={{ ...BLOCK, background: '#eff6ff', border: '1px solid #bfdbfe' }}>
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: '#1d4ed8' }}>{isFile ? 'From your file' : 'From your bank'}</div>
        <div>{m.account_name}: {m.transaction_date} {m.description} {money(m.amount)} ({m.direction === 'in' ? 'in' : 'out'})</div>
        {m.reason === 'before_last_import' && (
          <div data-testid="match-before-import" style={HINT}>Dated on or before the newest row already in this account (from a file import or typed in), so it was not added on its own.</div>
        )}
        {m.reason === 'reconciled_month' && (
          <div data-testid="match-reconciled-month" style={HINT}>Dated in a month that is already reconciled, so it was not added on its own. Add it only if the reconciled month really is missing it.</div>
        )}
      </div>
      <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: '#6b7280', marginTop: 8 }}>Already in eloNest</div>
      {(m.candidates || []).map((c) => {
        const locked = c.reconciled && m.source === 'plaid';
        return (
          <div key={c.id} data-testid="match-candidate" style={{ ...BLOCK, background: '#fff', border: '1px solid #e5e7eb' }}>
            <div>
              {c.transaction_date} {c.description} {money(c.amount)}{' '}
              {c.reconciled && (
                <span data-testid="reconciled-badge" style={{ fontSize: 11, background: '#dcfce7', color: '#166534', borderRadius: 999, padding: '1px 8px' }}>Reconciled</span>
              )}
            </div>
            <div style={{ marginTop: 4 }}>
              <ActionButton action="link" disabled={busy || locked} onClick={() => onResolve(m, 'link', c.id)} />
              {locked && <div style={HINT}>A reconciled row can't be linked. Choose one of the options below.</div>}
            </div>
          </div>
        );
      })}
      <div style={{ marginTop: 8 }}>
        <ActionButton action="keep_both" disabled={busy} onClick={() => onResolve(m, 'keep_both')} />
        <ActionButton action="dismiss" disabled={busy} onClick={() => onResolve(m, 'dismiss')} />
      </div>
    </div>
  );
}